import { FetchPolicy } from '@apollo/client'
import { useProvidersQuery } from '../graphql'

export default function useProvidersSearch( search: string, debounceKey = 'providersQuery-debounce' ) {
	const queryParams = {
		context: { debounceKey },
		fetchPolicy: 'no-cache' as FetchPolicy,
		variables: { ...( search ? { names: [ search ] } : {} ) },
	}

	return useProvidersQuery( queryParams )
}
